import { getCurrentUserAuth as e } from "../api/services/index.js";
import { restoreUserFromCache as t, authUser as s, getUser as o } from "./index2.js";
import { promiseAllCached as a } from "../../../libraries/index.js";
const c = async () => {
  t();
  const r = await e();
  r.succeeded && s(r.result);
};
async function u(r = [c]) {
  return await a(r), o();
}
export {
  u as getUserAsync,
  c as loadUser
};
//# sourceMappingURL=index.js.map
